enum CustomFilterKeys {
  CAPTURE_REPORT = "captureReport",
  INCIDENT_REPORT = "incidentReport"
}
export default CustomFilterKeys;
